/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_EInputs */



/**
* | output |
* | --- |
* | "Program E" |
*
* @param {Subtitle_Export_Program_EInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_e = /** @type {((inputs?: Subtitle_Export_Program_EInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_EInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Programme E")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programm E")
	if (locale === "it") return /** @type {LocalizedString} */ ("Programma E")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Программа Е")
	if (locale === "es") return /** @type {LocalizedString} */ ("Programa E")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("程序 E")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムE")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम ई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Programa E")
	return /** @type {LocalizedString} */ ("Program E")
});